import LazyLoad from 'react-lazyload';
import * as styles from './styles/styles.module.scss';

type ShopifyCardProps = {
  title: string;
  shopItemUrl: string;
  image: {
    src: string;
    altText: string;
  };
  price: string;
};

const ShopifyCard = ({ title, image, shopItemUrl, price }: ShopifyCardProps): JSX.Element => {
  return (
    <a className={styles.container} target="_blank" rel="noreferrer" href={shopItemUrl}>
      <div className={styles.imageContainer}>
        <LazyLoad>
          <img src={image.src} alt={image.altText} className={styles.image} />
        </LazyLoad>
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.price}>{price}</div>
    </a>
  );
};

export default ShopifyCard;
